// extracted by mini-css-extract-plugin
export default {"small-icon-container":"ChatToolbarButton__small-icon-container__co1XZ","smallIconContainer":"ChatToolbarButton__small-icon-container__co1XZ"};